import { api } from "@/comn";
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import utils, { comnUtils } from "@/comn/utils";
import { ptlEnvs } from "../../../comn";
import { format } from "path";
/*
 *  Exchange Rate Management Service
 * !== 환율 관리 기능 서비스 ==!
 */

export const BASE = {
    path: `${ptlEnvs.base}/crtr/exrt`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/crtr/exrt-mgmt`,
    nodes: [{ label: "Portal" }, { label: "Criteria Information Management" }, { label: "Exchange Rate Management" }],
};

export const URLS = {
    ptli0405001q: `${BASE.path}/ptli0405001q`, // Exchange Rate Management List !== 환율 관리 목록 ==!
};

export const APIS = {
    // Retrieve a list of Exchange Rate management. !== 환율관리 목록을 조회한다.==!
    getExrtMgmtList: (data: any, page: number, size: number) => {
        if (!comnUtils.isEmpty(data.ctraExrtMdfyDt)) data.ctraExrtMdfyDt = data.ctraExrtMdfyDt.split("-").join("");
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },

    // Save Exchange Rate Management information !== 환율관리 정보 저장 ==!
    insertExrtMgmtInfo: (data: any) => {
        if (!comnUtils.isEmpty(data.ctraExrtMdfyDt)) data.ctraExrtMdfyDt = data.ctraExrtMdfyDt.split("-").join("");
        if (!comnUtils.isEmpty(data.appdStrtDt)) data.appdStrtDt = data.appdStrtDt.split("-").join("");
        if (!comnUtils.isEmpty(data.appdEndDt)) data.appdEndDt = data.appdEndDt.split("-").join("");

        return api.post(`${BASE.api}`, {
            ...data,
        });
    },
};

// Exchange Rate Management Search Form !== 지역 코드 관리 검색 폼 ==!
export const SF_EXRT_MGMT_SRCH: TFormSchema = {
    id: "form_exrtMgmtSrch",
    schema: {
        ctraExrtMdfyDt: {
            type: "daterange",
            label: "L_CTRA_EXRT_MDFY_DT",
            start: { name: "ctraExrtMdfyDtStrt", required: true },
            end: {
                name: "ctraExrtMdfyDtEnd",
                validate: (value: any, formValues: any) => {
                    // 종료일자와 시작일자를 비교하여 오류검증 실행
                    // formValues.startDate 처럼 시작일자(startDate) 필드를 지정해서 비교
                    return comnUtils.dateDiff(value, formValues.ctraExrtMdfyDtStrt) < 0 ? "msg.cgm.00034" : true;
                },
                required: true,
            },
            rangeButton: 0,
        },
        currCd: { type: "select", label: "L_CURR_CD", area: "comnCd", comnCd: "COM0004" },
    },
};

// Exchange Rate Management List Grid Schema !== 환율 관리 목록 그리드 스키마 ==!
export const SG_EXRT_MGMT_LIST: TGridSchema = {
    id: "grid_exrtMgmtList",
    options: { pagination: "out", index: true, checkbox: false, importExcel: true },
    head: [
        { cells: [{ header: "L_CURR_CD", binding: "currCd", width: "*" }] },
        { cells: [{ header: "L_CURR_NM", binding: "currCdNm", width: "*" }] },
        { cells: [{ header: "L_CTRA_EXRT_MDFY_DT", binding: "ctraExrtMdfyDt", width: "*" }] },
        { cells: [{ header: "L_PUCH_EXRT", binding: "puchExrt", width: "*" }] },
        { cells: [{ header: "L_SALE_EXRT", binding: "saleExrt", width: "*" }] },
        { cells: [{ header: "L_APPD_STRT_DT", binding: "appdStrtDt", width: "*" }] },
        { cells: [{ header: "L_APPD_END_DT", binding: "appdEndDt", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "currCd", edit: false }] },
        { cells: [{ binding: "currCdNm", edit: false }] },
        { cells: [{ binding: "ctraExrtMdfyDt", edit: false, type: "date" }] },
        { cells: [{ binding: "puchExrt", edit: false, align: "right" }] },
        { cells: [{ binding: "saleExrt", edit: false, align: "right" }] },
        { cells: [{ binding: "appdStrtDt", edit: false, type: "date" }] },
        { cells: [{ binding: "appdEndDt", edit: false, type: "date" }] },
    ],
};

// Exchange Rate Management List Grid Schema !== 환율 관리 목록 그리드 스키마 ==!
export const SG_EXRT_MGMT_EXCEL_LIST: TGridSchema = {
    id: "grid_exrtMgmtList",
    options: { pagination: "out", index: true, checkbox: false },
    head: [
        { cells: [{ header: "L_CURR_CD", binding: "currCd", width: "*" }] },
        { cells: [{ header: "L_CTRA_EXRT_MDFY_DT", binding: "ctraExrtMdfyDt", width: "*" }] },
        { cells: [{ header: "L_PUCH_EXRT", binding: "puchExrt", width: "*" }] },
        { cells: [{ header: "L_SALE_EXRT", binding: "saleExrt", width: "*" }] },
        { cells: [{ header: "L_APPD_STRT_DT", binding: "appdStrtDt", width: "*" }] },
        { cells: [{ header: "L_APPD_END_DT", binding: "appdEndDt", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "currCd", edit: false }] },
        { cells: [{ binding: "ctraExrtMdfyDt", edit: false }] },
        { cells: [{ binding: "puchExrt", edit: false }] },
        { cells: [{ binding: "saleExrt", edit: false }] },
        { cells: [{ binding: "appdStrtDt", edit: false }] },
        { cells: [{ binding: "appdEndDt", edit: false }] },
    ],
};
